import BigNumber from "bignumber.js";
import store from "../redux/store";
import getNumberBitDepth from './numberFormat';

// Конвертация валюты
const getAmountRate = (amount, rate, selectedRate) => {
  return amount
};
const getSybmolRate = (rate) => {
  let _sybmol = "";
  switch (rate) {
    case "USD": {
      _sybmol = "$"
      break
    }
    default: {
      _sybmol = "$";
      break;
    }
  }
  return _sybmol
}

const rateConvert = (amount, config = {decimalCount: 0, useSybmol: false}) => {
  let amountConvert = getNumberBitDepth(amount, config?.decimalCount || 0, config?.decimal || '.', config?.thousands || ' ');

  let sybmolRate = "";
  if (config?.useSybmol) {
    sybmolRate = getSybmolRate('USD');
  }

  return [sybmolRate, amountConvert].filter((t) => !!t).join(' ')
}

export default rateConvert
